<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup>
// props="['width','height','right1Data']"
"baseBar";
import { ref, onMounted, defineProps } from "vue";
import * as echarts from "echarts";
const props = defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  leftData1: {
    type: Array,
    default: () => [],
  },
});
console.log(props.leftData1);
const myEcharts = ref(null);

onMounted(() => {
  // let data = [
  //   { value: 287.5, name: "2023年全县生产总值" },
  //   { value: 54.57, name: "第一产业增加值" },
  //   { value: 93.51, name: "第二产业增加值" },
  //   { value: 139.44, name: "第三产业增加值" },
  // ];
  initChart(props.leftData1);
});

function initChart(leftData1) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);
  var xdata = leftData1[0];
  var data = leftData1[1];
  let colors = ["#11605B", "#2EFE95", "#ECA641", "#148FF9"];
  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        // 坐标轴指示器，坐标轴触发有效
        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
      },
      textStyle: {
        color: "#000",
        fontSize: "36",
      },
      formatter: function (params) {
        // params[0].data.nameCode
        let dot =
          '<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;background-color:#02C4DD"></span>';
        return params[0].name + "<br>" + params[0].value + "%";
      },
    },
    grid: {
      left: "5%",
      right: "5%",
      bottom: "10%",
      top: "15%",
      containLabel: true,
    },
    xAxis: {
      data: xdata,
      triggerEvent: true,
      axisTick: {
        show: false,
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: "rgba(255, 255, 255, 0.3)",
        },
      },
      axisLabel: {
        show: true,
        rotate: 0,
        interval: 0,
        textStyle: {
          // padding: [14,0,0,0],
          fontSize: 36,
          color: "#fffffff",
        },
      },
    },
    yAxis: {
      triggerEvent: true,
      nameTextStyle: {
        color: "rgba(255,255,255,1)",
        fontSize: 36,
        padding: [0, 0, 10, -20],
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "rgba(16, 32, 33, 1)",
        },
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: "rgba(255, 255, 255, 0.3)",
        },
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: "#fffffe",
          fontSize: 36,
        },
      },
    },
    series: [
      {
        name: "",
        barMinHeight: 10,
        type: "pictorialBar",
        barCategoryGap: "50%",
        symbol: "path://M0,10 L10,10 L5,0 L0,10 z",
        // symbol: "path://M0,10 L10,10 C5.5,10 5.5,5 5,0 C4.5,5 4.5,10 0,10 z",
        itemStyle: {
          normal: {
            color: function (params) {
              return {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: colors[params.dataIndex],
                  },
                  {
                    offset: 0.3,
                    color: colors[params.dataIndex],
                  },
                  {
                    offset: 1,
                    color: "rgba(13,8,16,0)",
                  },
                ],
                global: false, //  缺省为  false
              };
            },
          },
          emphasis: {
            opacity: 1,
          },
        },
        label: {
          normal: {
            show: true,
            position: "top",
            textStyle: {
              color: "#fff",
              fontSize: 36,
            },
            formatter: function (params) {
              let index = params.dataIndex;
              let str = params.value + "%";
              return str;
            },
          },
        },
        data: data,
        z: 10,
      },
    ],
  }; // 将你的ECharts配置项放在这里
  if (option && typeof option === "object") {
    chartInstance.setOption(option, true);
    var index1 = 0; //播放所在下标
    var mTime = setInterval(function () {
      chartInstance.dispatchAction({
        type: "showTip",
        seriesIndex: 0,
        dataIndex: index1,
      });
      index1++;
      if (index1 >= 4) {
        //console.log('data4', fxdata.length)
        index1 = 0;
        //console.log(fxdata)
      }
    }, 2500);
  }
}
window.addEventListener("resize", () => {
  chartInstance.resize();
});
</script>
<style lang="less"></style>
